import { config, gameState } from '@js/state';

var attempts = 0;
var hintOn = false;

var finalRouteMap_Q4 = [];

var entryPoint = [0, 0];

var selectedCount_Q4 = 0;

var routeMapSet_Q4 = 1;

var newPointDistanceQ4 = 0;

var plantArrayQ4 = [[], [], [], [], [], [], [], [], [], [], [], [], []];

var plantLeftArrayQ4 = [[], [], [], [], [], [], [], [], [], []];

var leftEntrance_Q4 = new Phaser.Geom.Point(330, -200);

var leftQ4_p1 = new Phaser.Geom.Point(257, 265);
var leftQ4_p2 = new Phaser.Geom.Point(203, 391);
var leftQ4_p3 = new Phaser.Geom.Point(319, 478);
var leftQ4_p4 = new Phaser.Geom.Point(433, 393);

var leftExitWay_Q4 = new Phaser.Geom.Point(330, 1000);

var array1_Q4 = [];

var leftFinalRouteMap_Q4 = [leftEntrance_Q4, leftQ4_p1, leftQ4_p2, leftQ4_p3, leftQ4_p4, leftExitWay_Q4];

var leftRouteMapSet_Q4 = 1;

Array.prototype.insert = function (index, item) {
  this.splice(index, 0, item);
};

var entrance_Q4 = new Phaser.Geom.Point(0, 0);

var exitWay_Q4 = new Phaser.Geom.Point(0, 0);

var centerQ4 = new Phaser.Geom.Point(936, 355);

var startPointQ4 = new Phaser.Geom.Point(936, 210);

var Q4_p1 = new Phaser.Geom.Point(980.8, 217);
var Q4_p2 = new Phaser.Geom.Point(980.8, 217);
var Q4_p3 = new Phaser.Geom.Point(980.8, 217);
var Q4_p4 = new Phaser.Geom.Point(980.8, 217);
var Q4_p5 = new Phaser.Geom.Point(980.8, 217);
var Q4_p6 = new Phaser.Geom.Point(980.8, 217);
var Q4_p7 = new Phaser.Geom.Point(980.8, 217);
var Q4_p8 = new Phaser.Geom.Point(980.8, 217);
var Q4_p9 = new Phaser.Geom.Point(980.8, 217);
var Q4_p10 = new Phaser.Geom.Point(980.8, 217);

// debugger

var coordinateArrayQ4 = [Q4_p1, Q4_p2, Q4_p3, Q4_p4, Q4_p5, Q4_p6, Q4_p7, Q4_p8, Q4_p9, Q4_p10];

export default class GameSceneQ4 extends Phaser.Scene {
  constructor() {
    super({
      key: "GameSceneQ4",
    });
  }

  preload() {
    this.load.image("BGQ4", "assets/Q4/BGQ4.png");

    this.load.image("D_BGQ4", "assets/Q4/D_BGQ4.png");
    this.load.image("L_curbQ4", "assets/Q4/L_curbQ4.png");

    this.load.image("curbQ4", "assets/Q4/curbQ4.png");
    this.load.image("rightPlotQ4", "assets/Q4/rightPlotQ4.png");

    this.load.image("hitBoxQ4_1", "assets/Q4/hitBoxQ4_1.png");
    this.load.image("hitBoxQ4_2", "assets/Q4/hitBoxQ4_2.png");

    this.load.image("whiteBoxQ4_1", "assets/Q4/whiteBoxQ4_1.png");
    this.load.image("whiteBoxQ4_2", "assets/Q4/whiteBoxQ4_2.png");

    this.load.image("leftGreyBoxQ4", "assets/Q4/leftGreyBoxQ4.png");
  }

  create() {
    this.cameras.main.fadeIn(1500, 255, 255, 255);

    config.audio.bgaudio = this.sound.add("bgaudio").setVolume(0.02);
    config.audio.bgaudio.play();

    config.audio.hintAlert = this.sound.add("hintAlert").setVolume(0.05);
    config.audio.hover = this.sound.add("hover").setVolume(0.05);
    config.audio.correctAnswer = this.sound.add("correctAnswer").setVolume(0.05);
    config.audio.wrongAnswer = this.sound.add("wrongAnswer").setVolume(0.05);

    config.audio.waterCan = this.sound.add("waterCan").setVolume(0.05);
    config.audio.watering = this.sound.add("watering").setVolume(0.05);

    config.audio.sunShining = this.sound.add("sunShining").setVolume(0.05);
    config.audio.flowerBlossoming = this.sound.add("flowerBlossoming").setVolume(0.05);

    for (let i = 1; i < coordinateArrayQ4.length; i++) {
      Phaser.Math.RotateAround(coordinateArrayQ4[i], 936, 355, i * Phaser.Math.DegToRad(36));
    }

    this.BGQ4 = this.add.sprite(config.width / 2, config.height / 2, "D_BGQ4");

    this.progressBar = this.add.sprite(497.81, -12.89, "progressBar").setOrigin(0);

    this.correctGreen_1 = this.add.sprite(510, 17, "correctGreen").setOrigin(0).setDepth(0);
    this.correctGreen_2 = this.add.sprite(552, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_3 = this.add.sprite(594, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_4 = this.add.sprite(636, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_5 = this.add.sprite(678, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_6 = this.add.sprite(719.2, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.scoreRefresh();

    this.deselectText = this.add
      .sprite(config.width / 2, config.height / 2, "deselectText")
      .setDepth(1)
      .setVisible(false);
    this.hand = this.add.sprite(783, 179, "hand").setOrigin(0.2, 0.2).setVisible(false).setDepth(6);

    this.addWaterButton = this.add.sprite(860, 624, "addWaterButton").setInteractive({ cursor: "pointer" }).setOrigin(0);

    this.curbQ4 = this.add.sprite(570, 3, "L_curbQ4").setOrigin(0).setDepth(2);
    this.add.sprite(665, 84, "rightPlotQ4").setOrigin(0).setDepth(2);

    this.hitBoxQ4_1 = this.add.sprite(936, 355, "hitBoxQ4_1").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(0).setDepth(2);
    this.hitBoxQ4_2 = this.add.sprite(936, 355, "hitBoxQ4_2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(0).setDepth(2);
    this.hitBoxQ4_3 = this.add.sprite(936, 355, "hitBoxQ4_1").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(72).setDepth(2);
    this.hitBoxQ4_4 = this.add.sprite(936, 355, "hitBoxQ4_2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(72).setDepth(2);
    this.hitBoxQ4_5 = this.add.sprite(936, 355, "hitBoxQ4_1").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(144).setDepth(2);
    this.hitBoxQ4_6 = this.add.sprite(936, 355, "hitBoxQ4_2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(144).setDepth(2);
    this.hitBoxQ4_7 = this.add.sprite(936, 355, "hitBoxQ4_1").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(216).setDepth(2);
    this.hitBoxQ4_8 = this.add.sprite(936, 355, "hitBoxQ4_2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(216).setDepth(2);
    this.hitBoxQ4_9 = this.add.sprite(936, 355, "hitBoxQ4_1").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(288).setDepth(2);
    this.hitBoxQ4_10 = this.add.sprite(936, 355, "hitBoxQ4_2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(288).setDepth(2);

    this.whiteBoxQ4_1 = this.add.sprite(936, 355, "whiteBoxQ4_1").setOrigin(0, 1).setVisible(false).setAngle(0).setDepth(2);
    this.whiteBoxQ4_2 = this.add.sprite(936, 355, "whiteBoxQ4_2").setOrigin(0, 1).setVisible(false).setAngle(0).setDepth(2);
    this.whiteBoxQ4_3 = this.add.sprite(936, 355, "whiteBoxQ4_1").setOrigin(0, 1).setVisible(false).setAngle(72).setDepth(2);
    this.whiteBoxQ4_4 = this.add.sprite(936, 355, "whiteBoxQ4_2").setOrigin(0, 1).setVisible(false).setAngle(72).setDepth(2);
    this.whiteBoxQ4_5 = this.add.sprite(936, 355, "whiteBoxQ4_1").setOrigin(0, 1).setVisible(false).setAngle(144).setDepth(2);
    this.whiteBoxQ4_6 = this.add.sprite(936, 355, "whiteBoxQ4_2").setOrigin(0, 1).setVisible(false).setAngle(144).setDepth(2);
    this.whiteBoxQ4_7 = this.add.sprite(936, 355, "whiteBoxQ4_1").setOrigin(0, 1).setVisible(false).setAngle(216).setDepth(2);
    this.whiteBoxQ4_8 = this.add.sprite(936, 355, "whiteBoxQ4_2").setOrigin(0, 1).setVisible(false).setAngle(216).setDepth(2);
    this.whiteBoxQ4_9 = this.add.sprite(936, 355, "whiteBoxQ4_1").setOrigin(0, 1).setVisible(false).setAngle(288).setDepth(2);
    this.whiteBoxQ4_10 = this.add.sprite(936, 355, "whiteBoxQ4_2").setOrigin(0, 1).setVisible(false).setAngle(288).setDepth(2);

    this.leftGreyBoxQ4 = this.add.sprite(90, 118, "leftGreyBoxQ4").setOrigin(0).setVisible(false);

    this.anims.create({
      key: "sunrise",
      frames: this.anims.generateFrameNames("sunAnim", {
        start: 0,
        end: 348,
        zeroPad: 0,
        prefix: "sunAnim",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.anims.create({
      key: "shake",
      frames: this.anims.generateFrameNames("wrongPlacardAnim", {
        start: 1,
        end: 27,
        zeroPad: 0,
        prefix: "wrongPlacard",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: "idle",
      frames: this.anims.generateFrameNames("wrongPlacardAnim", {
        start: 0,
        end: 0,
        zeroPad: 0,
        prefix: "wrongPlacard",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.Q4_ans = this.add.sprite(0, 0, "wrongPlacardAnim").setOrigin(0).setDepth(2);

    this.Q4_qn = this.add.sprite(20.14, 473.2, "qnBoard").setOrigin(0);

    this.sun = this.add.sprite(0, 0, "sunAnim").setOrigin(0).setDepth(8);

    this.leftLine = this.add.sprite(55, 547, "line").setOrigin(0);
    this.rightLine = this.add.sprite(691, 548, "line").setOrigin(0).setDepth(2);

    this.inputWindow = this.add.sprite(690, 500, "inputWindow").setOrigin(0);

    this.Q4_leftNr = this.add.text(78, 523, "0", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setVisible(true);
    this.Q4_leftDr = this.add.text(78, 578, "5", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5);

    this.Q4_input = this.add.text(715, 523, "0", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setVisible(true).setDepth(2);
    this.Q4_rightDr = this.add.text(715, 578, "10", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setDepth(2);

    this.can = this.add.sprite(-200, -200, "wateringCanAnim").setOrigin(0.85, 0.9).setDepth(6);
    this.add.sprite(692.22, 646.37, "grass").setOrigin(0).setDepth(2);

    // this.Q4_qn = this.add.sprite(20.14,473.2, "qnBoard").setOrigin(0);
    // this.Q4_ans = this.add.sprite(654.14,474.2, "ansBoard").setOrigin(0);

    this.anims.create({
      key: "floweringQ4",
      frames: this.anims.generateFrameNames("flowering1Anim", {
        start: 30,
        end: 75,
        zeroPad: 0,
        prefix: "FLOWER",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    //>1

    this.hint = this.add.sprite(255, 552, "hint_1").setScale(0.8).setVisible(false).setDepth(7);

    this.closeHintButton = this.add.sprite(445, 450, "closeHint").setVisible(false).setDepth(7).setInteractive({ cursor: "pointer" });

    // this.hintButton = this.physics.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(7).setInteractive({ cursor: "pointer" });

    this.hintButton = this.physics.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(7);

    this.anims.create({
      key: "pop",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 0,
        end: 35,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "breathe",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 66,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "idlehint",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 37,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "pop_out",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 35,
        end: 0,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.overlay = this.add
      .sprite(config.width / 2, config.height / 2, "overlay")
      .setBlendMode(Phaser.BlendModes.MULTIPLY)
      .setVisible(false);

    this.handleHintButton();

    //<1

    this.waterPlantOnLeftQ4();

    // this.hitboxClickAndHoverHandle();
    // this.handleAddWaterButton();

    // var graphics = this.add.graphics();

    // graphics.fillStyle(0xff0000, 1);

    // graphics.fillCircle(centerQ4.x, centerQ4.y, 4);

    // graphics.fillCircle(startPointQ4.x, startPointQ4.y, 4);

    // graphics.fillCircle(Q4_p1.x, Q4_p1.y, 4);
    // graphics.fillCircle(Q4_p2.x, Q4_p2.y, 4);
    // graphics.fillCircle(Q4_p3.x, Q4_p3.y, 4);
    // graphics.fillCircle(Q4_p4.x, Q4_p4.y, 4);
    // graphics.fillCircle(Q4_p5.x, Q4_p5.y, 4);
    // graphics.fillCircle(Q4_p6.x, Q4_p6.y, 4);
    // graphics.fillCircle(Q4_p7.x, Q4_p7.y, 4);
    // graphics.fillCircle(Q4_p8.x, Q4_p8.y, 4);
    // graphics.fillCircle(Q4_p9.x, Q4_p9.y, 4);
    // graphics.fillCircle(Q4_p10.x, Q4_p10.y, 4);
  }

  waterPlantOnLeftQ4() {
    this.time.delayedCall(
      1500,
      () => {
        this.leftGreyBoxQ4.setVisible(true);

        this.moveCanInitial(leftFinalRouteMap_Q4[0].x, leftFinalRouteMap_Q4[0].y, leftFinalRouteMap_Q4[1].x, leftFinalRouteMap_Q4[1].y);
      },
      [],
      this
    );
  }

  startQuestionQ4() {
    //>//>>>hidden_console.log("startQ4");

    this.hitboxClickAndHoverHandle();
    this.handleAddWaterButton();
  }

  moveCanInitial(fromX, fromY, toX, toY) {
    this.time.delayedCall(
      1260,
      () => {
        this.waterTheLeftPlant(0);
        // leafArray[startRouteCount-1].play("plantbudding").setVisible(true);

        // this.createPlants(leftFinalRouteMap_Q4[leftRouteMapSet_Q4-1],leftRouteMapSet_Q4-1);
      },
      [],
      this
    );

    this.time.delayedCall(
      700,
      () => {
        this.createLeftPlants(leftFinalRouteMap_Q4[leftRouteMapSet_Q4 - 1], leftRouteMapSet_Q4 - 1);
      },
      [],
      this
    );

    this.tweens.add({
      targets: this.can,
      duration: 1050,
      ease: "Cubic",
      delay: 350,
      yoyo: false,
      x: { from: fromX, to: toX },
      y: { from: fromY, to: toY },
      completeDelay: 350,
      onComplete: () => {
        if (leftRouteMapSet_Q4 < leftFinalRouteMap_Q4.length - 1) {
          this.Q4_leftNr.setText(leftRouteMapSet_Q4);

          this.moveCanInitial(leftFinalRouteMap_Q4[leftRouteMapSet_Q4].x, leftFinalRouteMap_Q4[leftRouteMapSet_Q4].y, leftFinalRouteMap_Q4[leftRouteMapSet_Q4 + 1].x, leftFinalRouteMap_Q4[leftRouteMapSet_Q4 + 1].y);

          leftRouteMapSet_Q4 = leftRouteMapSet_Q4 + 1;
          //>//>>>hidden_console.log(leftRouteMapSet_Q4);
        } else {
          this.Q4_leftNr.setVisible(true);
          this.Q4_input.setVisible(true);

          this.startQuestionQ4();
        }
      },
      onCompleteScope: this,
    });
  }

  buddingToFlowering() {
    config.audio.flowerBlossoming.play();

    for (var k5 = 0; k5 < plantLeftArrayQ4.length; k5++) {
      for (var l5 = 0; l5 < plantLeftArrayQ4[k5].length; l5++) {
        plantLeftArrayQ4[k5][l5].setTexture("flowering1Anim").play("floweringQ4");

        //>//>>>hidden_console.log(l5 + " " + k5);
      }
    }

    // plantLeftArrayQ4[1][1].setTexture("flowering1Anim").play("floweringQ4");

    for (var k = 0; k < plantArrayQ4.length; k++) {
      for (var l = 0; l < plantArrayQ4[k].length; l++) {
        plantArrayQ4[k][l].setTexture("flowering1Anim").play("floweringQ4");
      }
    }

    // this.time.delayedCall(5000, () => {

    //   this.scene.stop("GameSceneQ4");
    //   this.scene.start('GameSceneQ5');

    // },[],this);

    this.removeClicking();
    this.changeScene();
  }

  pathFinding() {
    finalRouteMap_Q4.push(array1_Q4[0]);

    array1_Q4.splice(0, 1);

    ////>//>>>hidden_console.log(array1_Q4)

    for (let i = 0; i < finalRouteMap_Q4.length; i++) {
      var distanceArray = [];
      for (let j = 0; j < array1_Q4.length; j++) {
        // var dist = Math.sqrt(Math.pow(finalRouteMap_Q4[i][0] - array1_Q4[j][0], 2) + Math.pow(finalRouteMap_Q4[i][1] - array1_Q4[j][1], 2));
        var dist = Phaser.Math.Distance.BetweenPoints(finalRouteMap_Q4[i], array1_Q4[j]);
        distanceArray.push(dist);
      }
      var index = distanceArray.indexOf(Math.min(...distanceArray));

      finalRouteMap_Q4.push(array1_Q4[index]);
      array1_Q4.splice(index, 1);
      //>//>>>hidden_console.log(finalRouteMap_Q4);

      if (finalRouteMap_Q4.length == 8) {
        break;
      }
    }
  }

  changeScene() {
    //>//>>>hidden_console.log("ready to change scene");
    gameState.attempted = gameState.attempted + 1;

    this.tweens.add({
      targets: config.audio.bgaudio,
      volume: 0.005,
      duration: 4000,
      onComplete: () => {},
    });

    this.time.delayedCall(
      3000,
      function () {
        this.time.delayedCall(
          1000,
          function () {
            this.cameras.main.fadeOut(1000, 255, 255, 255);
          },
          [],
          this
        );

        this.cameras.main.once(
          "camerafadeoutcomplete",
          function (camera) {
            config.audio.bgaudio.stop();
            config.audio.flowerBlossoming.stop();
            config.audio.sunShining.stop();

            attempts = 0;

            this.wipeSceneQ4();

            if (gameState.score >= 5) {
              gameState.gameWin = true;
              this.scene.stop("GameSceneQ4");
              this.scene.start("EndScene");
            } else if (gameState.attempted == 9) {
              gameState.gameWin = false;
              this.scene.stop("GameSceneQ4");
              this.scene.start("EndScene");
            } else {
              this.scene.stop("GameSceneQ4");
              this.scene.start("GameSceneQ5");
            }

            this.cameras.main.fadeIn(1000, 255, 255, 255);

            // this.time.delayedCall(
            //   2000,
            //   function () {
            // this.cameras.main.fadeIn(1000, 255, 255, 255);
            //   },
            //   [],
            //   this
            // );
          },
          this
        );

        // if (gameState.attempted == 10) {
        //   gameState.gameWin = false;
        //   // this.scene.stop("TutorialScene");
        //   this.scene.start("EndScene");
        // }
      },
      [],
      this
    );
  }

  wipeSceneQ4() {
    attempts = 0;
    hintOn = false;

    finalRouteMap_Q4 = [];

    entryPoint = [0, 0];

    selectedCount_Q4 = 0;

    routeMapSet_Q4 = 1;

    newPointDistanceQ4 = 0;

    plantArrayQ4 = [[], [], [], [], [], [], [], [], [], [], []];

    plantLeftArrayQ4 = [[], [], [], [], [], [], [], [], [], []];

    // leftFinalRouteMap_Q4 = [leftEntrance_Q4,leftQ4_p1,leftExitWay_Q4];
    leftRouteMapSet_Q4 = 1;

    entrance_Q4.setTo(0, 0);

    exitWay_Q4.setTo(0, 0);

    Q4_p1.setTo(980.8, 217);
    Q4_p2.setTo(980.8, 217);
    Q4_p3.setTo(980.8, 217);
    Q4_p4.setTo(980.8, 217);
    Q4_p5.setTo(980.8, 217);
    Q4_p6.setTo(980.8, 217);
    Q4_p7.setTo(980.8, 217);
    Q4_p8.setTo(980.8, 217);
    Q4_p9.setTo(980.8, 217);
    Q4_p10.setTo(980.8, 217);

    array1_Q4 = [];
  }

  toggleHit(hitboxname, xcode, ycode) {
    this.hideDeselect();

    //>//>>>hidden_console.log(this.getPointFromCode(xcode,ycode));

    if (hitboxname.alpha == 0.1) {
      hitboxname.setAlpha(1);

      this.updateRouteMap(xcode, ycode);

      selectedCount_Q4 += 1;

      this.Q4_input.setText(selectedCount_Q4);
    } else {
      hitboxname.setAlpha(0.1);

      Phaser.Utils.Array.Remove(array1_Q4, this.getPointFromCode(xcode, ycode));

      selectedCount_Q4 -= 1;
      this.Q4_input.setText(selectedCount_Q4);

      //>//>>>hidden_console.log(finalRouteMap_Q4);
    }
  }

  updateRouteMap(xcode, ycode) {
    array1_Q4.push(this.getPointFromCode(xcode, ycode));

    // if(finalRouteMap_Q4.length <= 1){

    //   finalRouteMap_Q4.push(this.getPointFromCode(xcode,ycode));

    // }
    // else {

    //   newPointDistanceQ4 = this.calculateDistance(finalRouteMap_Q4[0], this.getPointFromCode(xcode,ycode));

    //   //>//>>>hidden_console.log(newPointDistanceQ4);

    //   var routeMapLength_Q4 = finalRouteMap_Q4.length;

    //   for(var i = 0; i < routeMapLength_Q4-1 ; i++){
    //     //>//>>>hidden_console.log(Phaser.Math.Distance.BetweenPoints(finalRouteMap_Q4[0],finalRouteMap_Q4[i+1]));

    //     if(Phaser.Math.Distance.BetweenPoints(finalRouteMap_Q4[0],finalRouteMap_Q4[i+1]) > newPointDistanceQ4){

    //       if(xcode == 0 && ycode == 0){ finalRouteMap_Q4.insert(i+1, Q4_p1); }
    //       else if(xcode == 1 && ycode == 0){ finalRouteMap_Q4.insert(i+1, Q4_p2); }

    //       else if(xcode == 0 && ycode == 1){ finalRouteMap_Q4.insert(i+1, Q4_p3); }
    //       else if(xcode == 1 && ycode == 1){ finalRouteMap_Q4.insert(i+1, Q4_p4); }

    //       else if(xcode == 0 && ycode == 2){ finalRouteMap_Q4.insert(i+1, Q4_p5); }
    //       else if(xcode == 1 && ycode == 2){ finalRouteMap_Q4.insert(i+1, Q4_p6); }

    //       else if(xcode == 0 && ycode == 3){ finalRouteMap_Q4.insert(i+1, Q4_p7); }
    //       else if(xcode == 1 && ycode == 3){ finalRouteMap_Q4.insert(i+1, Q4_p8); }

    //       else if(xcode == 0 && ycode == 4){ finalRouteMap_Q4.insert(i+1, Q4_p9); }
    //       else if(xcode == 1 && ycode == 4){ finalRouteMap_Q4.insert(i+1, Q4_p10); }

    //     }else{
    //       if(xcode == 0 && ycode == 0){ finalRouteMap_Q4.push(Q4_p1); }
    //       else if(xcode == 1 && ycode == 0){ finalRouteMap_Q4.push(Q4_p2); }

    //       else if(xcode == 0 && ycode == 1){ finalRouteMap_Q4.push(Q4_p3); }
    //       else if(xcode == 1 && ycode == 1){ finalRouteMap_Q4.push(Q4_p4); }

    //       else if(xcode == 0 && ycode == 2){ finalRouteMap_Q4.push(Q4_p5); }
    //       else if(xcode == 1 && ycode == 2){ finalRouteMap_Q4.push(Q4_p6); }

    //       else if(xcode == 0 && ycode == 3){ finalRouteMap_Q4.push(Q4_p7); }
    //       else if(xcode == 1 && ycode == 3){ finalRouteMap_Q4.push(Q4_p8); }

    //       else if(xcode == 0 && ycode == 4){ finalRouteMap_Q4.push(Q4_p9); }
    //       else if(xcode == 1 && ycode == 4){ finalRouteMap_Q4.push(Q4_p10); }

    //     }
    //     break;

    //   }
    // }
    // //>//>>>hidden_console.log(finalRouteMap_Q4);
  }

  getPointFromCode(xcode, ycode) {
    if (xcode == 0 && ycode == 0) {
      return Q4_p1;
    } else if (xcode == 1 && ycode == 0) {
      return Q4_p2;
    } else if (xcode == 0 && ycode == 1) {
      return Q4_p3;
    } else if (xcode == 1 && ycode == 1) {
      return Q4_p4;
    } else if (xcode == 0 && ycode == 2) {
      return Q4_p5;
    } else if (xcode == 1 && ycode == 2) {
      return Q4_p6;
    } else if (xcode == 0 && ycode == 3) {
      return Q4_p7;
    } else if (xcode == 1 && ycode == 3) {
      return Q4_p8;
    } else if (xcode == 0 && ycode == 4) {
      return Q4_p9;
    } else if (xcode == 1 && ycode == 4) {
      return Q4_p10;
    }
  }

  scoreUpdate() {
    gameState.score = gameState.score + 1;

    //>//>>>hidden_console.log("score: " + gameState.score);

    if (gameState.score >= 1) {
      this.correctGreen_2.setVisible(true);
    }
    if (gameState.score >= 2) {
      this.correctGreen_3.setVisible(true);
    }
    if (gameState.score >= 3) {
      this.correctGreen_4.setVisible(true);
    }
    if (gameState.score >= 4) {
      this.correctGreen_5.setVisible(true);
    }
    if (gameState.score >= 5) {
      this.correctGreen_6.setVisible(true);
    }
  }

  handleAddWaterButton() {
    this.addWaterButton.on("pointerover", () => {
      this.addWaterButton.setTexture("hover_addWaterButton");
    });
    this.addWaterButton.on("pointerout", () => {
      this.addWaterButton.setTexture("addWaterButton");
    });
    this.addWaterButton.on("pointerup", () => {
      this.removeClicking();
      ////

      if (selectedCount_Q4 == 8) {
        this.pathFinding();

        config.audio.correctAnswer.play();
        this.tweens.add({
          targets: this.addWaterButton,
          duration: 500,
          ease: "easeInOutSine",
          //delay: 100,
          yoyo: false,
          // x: {from:783, to:1069},
          y: { from: 624, to: 800 },
          // scale: {from:1, to:0.8},
          loop: 0,
        });

        this.hintButton.removeInteractive();
        this.hideDeselect();

        if (hintOn == true) {
          this.hintButton.play("pop_out");
          hintOn = false;
        }

        //gameState.score = gameState.score + 1;

        //>//>>>hidden_console.log("score: " + gameState.score);

        //<2

        this.Q4_ans.setTint(0xffffff);

        this.removeClicking();

        this.scoreUpdate();

        if (finalRouteMap_Q4[0] == Q4_p1) {
          entrance_Q4.setTo(727, -200);
        } else if (finalRouteMap_Q4[0] == Q4_p2) {
          entrance_Q4.setTo(844, -200);
        } else if (finalRouteMap_Q4[0] == Q4_p3) {
          entrance_Q4.setTo(961, -200);
        } else if (finalRouteMap_Q4[0] == Q4_p4) {
          entrance_Q4.setTo(2078, 203);
        } else if (finalRouteMap_Q4[0] == Q4_p5) {
          entrance_Q4.setTo(727, 900);
        } else if (finalRouteMap_Q4[0] == Q4_p6) {
          entrance_Q4.setTo(844, 900);
        } else if (finalRouteMap_Q4[0] == Q4_p7) {
          entrance_Q4.setTo(961, 900);
        } else if (finalRouteMap_Q4[0] == Q4_p8) {
          entrance_Q4.setTo(2078, 326);
        } else if (finalRouteMap_Q4[0] == Q4_p9) {
          entrance_Q4.setTo(961, 900);
        } else if (finalRouteMap_Q4[0] == Q4_p10) {
          entrance_Q4.setTo(2078, 326);
        }

        finalRouteMap_Q4.unshift(entrance_Q4);

        if (finalRouteMap_Q4[finalRouteMap_Q4.length - 1] == Q4_p1) {
          exitWay_Q4.setTo(727, -200);
        } else if (finalRouteMap_Q4[finalRouteMap_Q4.length - 1] == Q4_p2) {
          exitWay_Q4.setTo(844, -200);
        } else if (finalRouteMap_Q4[finalRouteMap_Q4.length - 1] == Q4_p3) {
          exitWay_Q4.setTo(961, -200);
        } else if (finalRouteMap_Q4[finalRouteMap_Q4.length - 1] == Q4_p4) {
          exitWay_Q4.setTo(2078, 203);
        } else if (finalRouteMap_Q4[finalRouteMap_Q4.length - 1] == Q4_p5) {
          exitWay_Q4.setTo(727, 900);
        } else if (finalRouteMap_Q4[finalRouteMap_Q4.length - 1] == Q4_p6) {
          exitWay_Q4.setTo(844, 900);
        } else if (finalRouteMap_Q4[finalRouteMap_Q4.length - 1] == Q4_p7) {
          exitWay_Q4.setTo(961, 900);
        } else if (finalRouteMap_Q4[finalRouteMap_Q4.length - 1] == Q4_p8) {
          exitWay_Q4.setTo(2078, 326);
        } else if (finalRouteMap_Q4[finalRouteMap_Q4.length - 1] == Q4_p9) {
          exitWay_Q4.setTo(961, 900);
        } else if (finalRouteMap_Q4[finalRouteMap_Q4.length - 1] == Q4_p10) {
          exitWay_Q4.setTo(2078, 326);
        }

        finalRouteMap_Q4.push(exitWay_Q4);

        this.moveCan(finalRouteMap_Q4[0].x, finalRouteMap_Q4[0].y, finalRouteMap_Q4[1].x, finalRouteMap_Q4[1].y);
      } else {
        config.audio.wrongAnswer.play();

        //>3

        this.incorrectAttempt();

        this.hintButton.removeInteractive();

        //<3

        // this.Q4_ans.setTint(0xFFC2A2);

        this.Q4_ans.play("shake");

        this.inputWindow.setVisible(false);

        this.rightLine.setTexture("redLine");

        this.Q4_rightDr.setFill("#C22300");
        this.Q4_input.setFill("#C22300");

        this.time.delayedCall(
          2500,
          () => {
            this.Q4_ans.play("idle");
            this.inputWindow.setVisible(true);

            this.rightLine.setTexture("line");

            this.Q4_rightDr.setFill("#2b2b2b");
            this.Q4_input.setFill("#2b2b2b");
          },
          [],
          this
        );
      }
    });
  }

  calculateDistance(target1, target2) {
    return Phaser.Math.Distance.BetweenPoints(target1, target2);
  }

  moveCan(fromX, fromY, toX, toY) {
    this.time.delayedCall(
      1260,
      () => {
        this.waterTheLeftPlant(100);
      },
      [],
      this
    );

    this.time.delayedCall(
      700,
      () => {
        this.createPlants(finalRouteMap_Q4[routeMapSet_Q4 - 1], routeMapSet_Q4 - 1);
      },
      [],
      this
    );

    this.tweens.add({
      targets: this.can,
      duration: 1050,
      ease: "Cubic",
      delay: 350,
      yoyo: false,
      x: { from: fromX, to: toX },
      y: { from: fromY, to: toY },
      completeDelay: 350,
      onComplete: () => {
        if (routeMapSet_Q4 < finalRouteMap_Q4.length - 1) {
          this.moveCan(finalRouteMap_Q4[routeMapSet_Q4].x, finalRouteMap_Q4[routeMapSet_Q4].y, finalRouteMap_Q4[routeMapSet_Q4 + 1].x, finalRouteMap_Q4[routeMapSet_Q4 + 1].y);

          routeMapSet_Q4 = routeMapSet_Q4 + 1;
          // //>//>>>hidden_console.log(routeMapSet_Q4);
        } else {
          config.audio.sunShining.play();

          this.tweens.add({
            targets: config.audio.sunShining,
            volume: 0.005,
            duration: 3000,
            onComplete: () => {},
          });

          this.sun.play("sunrise");

          this.time.delayedCall(
            3000,
            () => {
              this.buddingToFlowering();
              config.audio.sunShining.stop();
            },
            [],
            this
          );
        }
      },
      onCompleteScope: this,
    });
  }

  scoreRefresh() {
    //>//>>>hidden_console.log("score: " + gameState.score);
    if (gameState.score >= 1) {
      this.correctGreen_2.setVisible(true);
    }
    if (gameState.score >= 2) {
      this.correctGreen_3.setVisible(true);
    }
    if (gameState.score >= 3) {
      this.correctGreen_4.setVisible(true);
    }
    if (gameState.score >= 4) {
      this.correctGreen_5.setVisible(true);
    }
    if (gameState.score >= 5) {
      this.correctGreen_6.setVisible(true);
    }
  }
  showDeselect() {
    if (selectedCount_Q4 >= 8) {
      if (!gameState.firstMistake) {
        this.deselectText.setVisible(true);

        this.hand.setVisible(true);
        this.tweens.add({
          targets: this.hand,
          duration: 500,
          ease: "easeInOutSine",
          // delay: 500,
          yoyo: true,
          // x: {from:783, to:1069},
          // y: {from:179, to:640},
          scale: { from: 1, to: 0.8 },
          loop: -1,
        });

        this.hand.setPosition(array1_Q4[0].x, array1_Q4[0].y);
      }

      gameState.firstMistake = true;
    }
  }

  hideDeselect() {
    this.deselectText.setVisible(false);
    this.hand.setVisible(false);
  }

  hitboxClickAndHoverHandle() {
    this.BGQ4.setTexture("BGQ4");
    this.curbQ4.setTexture("curbQ4");

    this.hitBoxQ4_1.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ4_1, 0, 0);
      },
      this
    );
    this.hitBoxQ4_2.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ4_2, 1, 0);
      },
      this
    );
    this.hitBoxQ4_3.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ4_3, 0, 1);
      },
      this
    );
    this.hitBoxQ4_4.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ4_4, 1, 1);
      },
      this
    );
    this.hitBoxQ4_5.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ4_5, 0, 2);
      },
      this
    );
    this.hitBoxQ4_6.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ4_6, 1, 2);
      },
      this
    );
    this.hitBoxQ4_7.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ4_7, 0, 3);
      },
      this
    );
    this.hitBoxQ4_8.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ4_8, 1, 3);
      },
      this
    );
    this.hitBoxQ4_9.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ4_9, 0, 4);
      },
      this
    );
    this.hitBoxQ4_10.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ4_10, 1, 4);
      },
      this
    );

    // this.hitBoxQ4_1.on("pointerup", () => { this.toggleHit(this.hitBoxQ4_1, 0, 0); //>//>>>hidden_console.log("1")}, this);
    // this.hitBoxQ4_2.on("pointerup", () => { this.toggleHit(this.hitBoxQ4_2, 1, 0); //>//>>>hidden_console.log("2") }, this);
    // this.hitBoxQ4_3.on("pointerup", () => { this.toggleHit(this.hitBoxQ4_3, 0, 1); //>//>>>hidden_console.log("3") }, this);
    // this.hitBoxQ4_4.on("pointerup", () => { this.toggleHit(this.hitBoxQ4_4, 1, 1); //>//>>>hidden_console.log("4") }, this);
    // this.hitBoxQ4_5.on("pointerup", () => { this.toggleHit(this.hitBoxQ4_5, 0, 2); //>//>>>hidden_console.log("5") }, this);
    // this.hitBoxQ4_6.on("pointerup", () => { this.toggleHit(this.hitBoxQ4_6, 1, 2); //>//>>>hidden_console.log("6") }, this);
    // this.hitBoxQ4_7.on("pointerup", () => { this.toggleHit(this.hitBoxQ4_7, 0, 3); //>//>>>hidden_console.log("7") }, this);
    // this.hitBoxQ4_8.on("pointerup", () => { this.toggleHit(this.hitBoxQ4_8, 1, 3); //>//>>>hidden_console.log("8") }, this);
    // this.hitBoxQ4_9.on("pointerup", () => { this.toggleHit(this.hitBoxQ4_9, 0, 4); //>//>>>hidden_console.log("9") }, this);
    // this.hitBoxQ4_10.on("pointerup", () => { this.toggleHit(this.hitBoxQ4_10, 1, 4); //>//>>>hidden_console.log("10") }, this);

    this.hitBoxQ4_1.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ4(1);
      },
      this
    );
    this.hitBoxQ4_2.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ4(2);
      },
      this
    );
    this.hitBoxQ4_3.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ4(3);
      },
      this
    );
    this.hitBoxQ4_4.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ4(4);
      },
      this
    );
    this.hitBoxQ4_5.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ4(5);
      },
      this
    );
    this.hitBoxQ4_6.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ4(6);
      },
      this
    );
    this.hitBoxQ4_7.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ4(7);
      },
      this
    );
    this.hitBoxQ4_8.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ4(8);
      },
      this
    );
    this.hitBoxQ4_9.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ4(9);
      },
      this
    );
    this.hitBoxQ4_10.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ4(10);
      },
      this
    );

    this.hitBoxQ4_1.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ4();
      },
      this
    );
    this.hitBoxQ4_2.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ4();
      },
      this
    );
    this.hitBoxQ4_3.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ4();
      },
      this
    );
    this.hitBoxQ4_4.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ4();
      },
      this
    );
    this.hitBoxQ4_5.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ4();
      },
      this
    );
    this.hitBoxQ4_6.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ4();
      },
      this
    );
    this.hitBoxQ4_7.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ4();
      },
      this
    );
    this.hitBoxQ4_8.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ4();
      },
      this
    );
    this.hitBoxQ4_9.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ4();
      },
      this
    );
    this.hitBoxQ4_10.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ4();
      },
      this
    );
  }

  //>4
  handleHintButton() {
    this.hintButton.on(
      "pointerup",
      function (pointer) {
        ////
        gameState.hints += 1;

        this.hintButton.setVisible(true);

        this.hintButton.play("idlehint");

        this.removeClicking();

        if (attempts == 1) {
          this.hint.setTexture("hint_1");

          this.overlay.setVisible(true).setDepth(6);
          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
        } else if (attempts >= 2) {
          this.overlay.setVisible(true).setDepth(6);

          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
          this.hint.setTexture("hint_2");
        }
      },
      this
    );

    this.closeHintButton.on(
      "pointerup",
      function (pointer) {
        this.enableClicking();

        this.overlay.setVisible(false);
        this.hint.setVisible(false);
        this.closeHintButton.setVisible(false);
        this.hintButton.play("pop_out");
        this.hintButton.removeInteractive();

        hintOn = false;
      },
      this
    );
  }

  incorrectAttempt() {
    // correctAnswer = false;
    this.hintButton.setVisible(false);

    // ////

    attempts += 1;

    if (attempts == 1 || attempts == 2) {
      this.showDeselect();
    } else {
      this.addWaterButton.setTexture("disable_addWaterButton");
    }
    //>//>>>hidden_console.log(attempts);

    this.time.delayedCall(
      1000,
      function () {
        if (attempts == 1 || attempts == 2) {
          hintOn = true;

          this.hintButton.setVisible(true);

          this.hintButton.play("pop");
          config.audio.hintAlert.play();

          this.time.delayedCall(
            1300,
            () => {
              this.enableClicking();

              this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });
            },
            [],
            this
          );

          this.time.delayedCall(
            500,
            function () {
              if (hintOn) {
                this.hintButton.play("breathe");
              }
            },
            [],
            this
          );
        }
      },
      [],
      this
    );

    this.time.delayedCall(
      1800,
      function () {
        if (attempts == 1 || attempts == 2) {
          this.time.delayedCall(
            1300,
            () => {
              this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });
            },
            [],
            this
          );
        } else {
          this.removeClicking();
          this.changeScene();

          if (hintOn == true) {
            this.hintButton.play("pop_out");
            hintOn = false;
          }

          this.time.delayedCall(
            3300,
            function () {
              attempts = 0;
            },
            [],
            this
          );
        }
      },
      [],
      this
    );
  }

  //<4

  enableClicking() {
    this.hitBoxQ4_1.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ4_2.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ4_3.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ4_4.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ4_5.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ4_6.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ4_7.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ4_8.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ4_9.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ4_10.setInteractive({ cursor: "pointer", pixelPerfect: true });

    this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });

    this.addWaterButton.setInteractive({ cursor: "pointer" });
    this.addWaterButton.setTexture("addWaterButton");
  }

  ///<5

  removeClicking() {
    this.hitBoxQ4_1.removeInteractive();
    this.hitBoxQ4_2.removeInteractive();
    this.hitBoxQ4_3.removeInteractive();
    this.hitBoxQ4_4.removeInteractive();
    this.hitBoxQ4_5.removeInteractive();
    this.hitBoxQ4_6.removeInteractive();
    this.hitBoxQ4_7.removeInteractive();
    this.hitBoxQ4_8.removeInteractive();
    this.hitBoxQ4_9.removeInteractive();
    this.hitBoxQ4_10.removeInteractive();

    this.addWaterButton.removeInteractive();
    if (attempts == 0 || attempts == 1) {
      this.addWaterButton.setTexture("addWaterButton");
    }

    this.hintButton.removeInteractive();
  }

  showWhiteBoxQ4(position) {
    config.audio.hover.play();

    this.removeWhiteBoxQ4();

    if (position == 1) {
      this.whiteBoxQ4_1.setVisible(true);
    }
    if (position == 2) {
      this.whiteBoxQ4_2.setVisible(true);
    }
    if (position == 3) {
      this.whiteBoxQ4_3.setVisible(true);
    }
    if (position == 4) {
      this.whiteBoxQ4_4.setVisible(true);
    }
    if (position == 5) {
      this.whiteBoxQ4_5.setVisible(true);
    }
    if (position == 6) {
      this.whiteBoxQ4_6.setVisible(true);
    }
    if (position == 7) {
      this.whiteBoxQ4_7.setVisible(true);
    }
    if (position == 8) {
      this.whiteBoxQ4_8.setVisible(true);
    }
    if (position == 9) {
      this.whiteBoxQ4_9.setVisible(true);
    }
    if (position == 10) {
      this.whiteBoxQ4_10.setVisible(true);
    }
  }

  removeWhiteBoxQ4() {
    this.whiteBoxQ4_1.setVisible(false);
    this.whiteBoxQ4_2.setVisible(false);
    this.whiteBoxQ4_3.setVisible(false);
    this.whiteBoxQ4_4.setVisible(false);
    this.whiteBoxQ4_5.setVisible(false);
    this.whiteBoxQ4_6.setVisible(false);
    this.whiteBoxQ4_7.setVisible(false);
    this.whiteBoxQ4_8.setVisible(false);
    this.whiteBoxQ4_9.setVisible(false);
    this.whiteBoxQ4_10.setVisible(false);
  }

  createPlants(selectedPoint, plantSelectionCode) {
    if (selectedPoint == Q4_p1) {
      plantArrayQ4[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x + 10, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ4[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x - 25, selectedPoint.y + 50, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q4_p2) {
      plantArrayQ4[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x + 10, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ4[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x - 50, selectedPoint.y + 15, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q4_p3) {
      plantArrayQ4[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 50, selectedPoint.y - 15, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ4[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 10, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q4_p4) {
      plantArrayQ4[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ4[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x - 50, selectedPoint.y - 50, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q4_p5) {
      plantArrayQ4[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 25, selectedPoint.y + 5, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ4[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 10, selectedPoint.y - 50, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q4_p6) {
      plantArrayQ4[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y + 5, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ4[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 20, selectedPoint.y - 50, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q4_p7) {
      plantArrayQ4[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ4[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 40, selectedPoint.y - 50, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q4_p8) {
      plantArrayQ4[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ4[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 50, selectedPoint.y - 20, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q4_p9) {
      plantArrayQ4[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 20, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ4[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 30, selectedPoint.y, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q4_p10) {
      plantArrayQ4[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y - 20, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ4[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 25, selectedPoint.y + 40, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    }
  }

  // createPlants(selectedPoint,plantSelectionCode){

  //   if(selectedPoint ==  Q4_p1){
  //     plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  //     plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   //>//>>>hidden_console.log("1");
  //   }
  //   else if(selectedPoint ==  Q4_p2){
  //   plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  // //>//>>>hidden_console.log("2");
  // }
  //   else if(selectedPoint ==  Q4_p3){
  //     plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  //     plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   //>//>>>hidden_console.log("3");
  //   }
  //   else if(selectedPoint ==  Q4_p4){
  //     plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  //     plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   //>//>>>hidden_console.log("4");
  //   }
  //   else if(selectedPoint ==  Q4_p5){
  //     plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  //     plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   //>//>>>hidden_console.log("5");
  //   }
  //   else if(selectedPoint ==  Q4_p6){
  //     plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  //     plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   //>//>>>hidden_console.log("6");
  //   }
  //   else if(selectedPoint ==  Q4_p7){
  //     plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  //     plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   //>//>>>hidden_console.log("7");
  //   }
  //   else if(selectedPoint ==  Q4_p8){
  //     plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  //     plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   //>//>>>hidden_console.log("8");
  //   }
  //   else if(selectedPoint ==  Q4_p9){
  //     plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x+ 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  //     plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   //>//>>>hidden_console.log("9");
  //   }
  //   else if(selectedPoint ==  Q4_p10){
  //     plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  //     plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 0,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   //>//>>>hidden_console.log("10");
  //   }

  // }

  // createPlants(selectedPoint,plantSelectionCode){

  //   if(selectedPoint ==  Q4_p1){
  //     plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x + 10,selectedPoint.y - 10,"playSwayAnim").setScale(0.3).play("plantbudding");
  //     plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x - 25,selectedPoint.y + 40,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   }
  //   else if(selectedPoint ==  Q4_p2){
  //   plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x - 10,selectedPoint.y - 20,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x - 50,selectedPoint.y + 10,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   }
  //   else if(selectedPoint ==  Q4_p3){
  //     plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x - 50,selectedPoint.y - 20,"playSwayAnim").setScale(0.3).play("plantbudding");
  //     plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x + 10,selectedPoint.y - 20,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   }
  //   else if(selectedPoint ==  Q4_p4){
  //     plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x,selectedPoint.y - 30,"playSwayAnim").setScale(0.3).play("plantbudding");
  //     plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x - 80,selectedPoint.y - 70,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   }
  //   else if(selectedPoint ==  Q4_p5){
  //     plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x - 55,selectedPoint.y - 100,"playSwayAnim").setScale(0.3).play("plantbudding");
  //     plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x + 10,selectedPoint.y - 50,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   }
  //   else if(selectedPoint ==  Q4_p6){
  //     plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x + 10,selectedPoint.y - 10,"playSwayAnim").setScale(0.3).play("plantbudding");
  //     plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x - 10,selectedPoint.y - 100,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   }
  //   else if(selectedPoint ==  Q4_p7){
  //     plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x - 10,selectedPoint.y - 10,"playSwayAnim").setScale(0.3).play("plantbudding");
  //     plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x + 20,selectedPoint.y - 80,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   }
  //   else if(selectedPoint ==  Q4_p8){
  //     plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x - 10,selectedPoint.y - 10,"playSwayAnim").setScale(0.3).play("plantbudding");
  //     plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x + 50,selectedPoint.y - 50,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   }
  //   else if(selectedPoint ==  Q4_p9){
  //     plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x - 0,selectedPoint.y - 10,"playSwayAnim").setScale(0.3).play("plantbudding");
  //     plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x + 60,selectedPoint.y - 20,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   }
  //   else if(selectedPoint ==  Q4_p10){
  //     plantArrayQ4[plantSelectionCode][0] = this.add.sprite(selectedPoint.x - 10,selectedPoint.y + 10,"playSwayAnim").setScale(0.3).play("plantbudding");
  //     plantArrayQ4[plantSelectionCode][1] = this.add.sprite(selectedPoint.x + 35,selectedPoint.y - 20,"playSwayAnim").setScale(0.3).play("plantbudding");
  //   }

  // plantArrayQ4[plantSelectionCode][2] = this.add.sprite(selectedPoint.x + 10,selectedPoint.y + 50,"playSwayAnim").setScale(0.3).play("plantbudding");
  // plantArrayQ4[plantSelectionCode][3] = this.add.sprite(selectedPoint.x + 105,selectedPoint.y + 50,"playSwayAnim").setScale(0.3).play("plantbudding");

  // }

  createLeftPlants(selectedPoint, plantSelectionCode) {
    plantLeftArrayQ4[plantSelectionCode][0] = this.add
      .sprite(selectedPoint.x, selectedPoint.y - 70, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding");
    plantLeftArrayQ4[plantSelectionCode][1] = this.add
      .sprite(selectedPoint.x - 40, selectedPoint.y + 10, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding");
    plantLeftArrayQ4[plantSelectionCode][2] = this.add
      .sprite(selectedPoint.x + 40, selectedPoint.y + 10, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding");
    plantLeftArrayQ4[plantSelectionCode][3] = this.add
      .sprite(selectedPoint.x + 0, selectedPoint.y - 20, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding");

    // plantLeftArrayQ4[plantSelectionCode][4] = this.add.sprite(selectedPoint.x + 40,selectedPoint.y + 10,"playSwayAnim").setScale(0.3).play("plantbudding");

    // plantLeftArrayQ4[plantSelectionCode][5] = this.add.sprite(selectedPoint.x + 0,selectedPoint.y + 75,"playSwayAnim").setScale(0.3).play("plantbudding");
  }

  waterThePlant(flowingtime) {
    if (routeMapSet_Q4 <= selectedCount_Q4 || leftRouteMapSet_Q4 < leftFinalRouteMap_Q4.length - 1) {
      config.audio.watering.play();
    }

    this.can.play("startwatering");

    this.time.delayedCall(
      1000,
      () => {
        this.can.play("waterflowing");

        this.time.delayedCall(
          flowingtime,
          () => {
            this.can.play("stopwatering");
            config.audio.watering.stop();
          },
          [],
          this
        );
      },
      [],
      this
    );
  }

  waterTheLeftPlant(flowingtime) {
    if (routeMapSet_Q4 <= selectedCount_Q4 || leftRouteMapSet_Q4 < leftFinalRouteMap_Q4.length - 1) {
      config.audio.watering.play();
    }

    this.can.play("startwatering");

    this.time.delayedCall(
      700,
      () => {
        this.can.play("waterflowing");

        this.time.delayedCall(
          flowingtime,
          () => {
            this.can.play("stopwatering");
            config.audio.watering.stop();
          },
          [],
          this
        );
      },
      [],
      this
    );
  }

  update() {}
}
